import { FirebaseApp, getApps, initializeApp } from 'firebase/app'
import { getAuth, signOut } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const appName = 'office-time-tracker-front'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

const requiredValues = Object.values(firebaseConfig)

const isFirebaseConfigured = () => requiredValues.every(Boolean)

const getFirebaseApp = (): FirebaseApp => {
  if (!isFirebaseConfigured()) {
    throw new Error('Faltan variables de Firebase para Temporizador oficina en cocap-front')
  }

  const existingApp = getApps().find(app => app.name === appName)
  if (existingApp) {
    return existingApp
  }

  return initializeApp(firebaseConfig, appName)
}

const getFirebaseClients = () => {
  const app =
    getApps().find(currentApp => currentApp.name === appName) || (isFirebaseConfigured() ? getFirebaseApp() : null)

  if (!app) {
    throw new Error('Faltan variables de Firebase para Temporizador oficina en cocap-front')
  }

  return {
    clientAuth: getAuth(app),
    clientFirestore: getFirestore(app)
  }
}

const signOutOfficeTracker = async () => {
  const existingApp = getApps().find(app => app.name === appName)
  if (!existingApp) {
    return
  }

  await signOut(getAuth(existingApp))
}

export { getFirebaseClients, isFirebaseConfigured, signOutOfficeTracker }
